import {createApi, fetchBaseQuery, retry} from '@reduxjs/toolkit/query/react';
import {oktaAuth} from '../components/Okta/AuthService';

const staggeredBaseQuery = retry(
  fetchBaseQuery({
    baseUrl: process.env.REACT_APP_JAVA_API_URL,
    prepareHeaders: async (headers) => {
      const tokenObj = await oktaAuth.tokenManager.get('accessToken');
      const token = (tokenObj as {accessToken?: string} | undefined)
        ?.accessToken;
      if (token) headers.set('authorization', `Bearer ${token}`);
      return headers;
    },
  }),
  {maxRetries: 3},
);

export interface HomeCatalogMetrics {
  spend: number;
  savings: number;
}

export type HomeCatalogCategory =
  | 't&e'
  | 'contractor'
  | 'gss'
  | 'consulting'
  | 'tech';

export interface HomeCatalogResponse {
  spend: Record<HomeCatalogCategory, number>;
  savings: Record<HomeCatalogCategory, number>;
}

export interface HomeCatalogQueryArgs {
  isToggleEnabled: boolean;
  isImpersonationUser: boolean;
  impEmail: string;
}

export const homeCatalogApi = createApi({
  reducerPath: 'homeCatalogApi',
  baseQuery: staggeredBaseQuery,
  endpoints: (builder) => ({
    getHomeCatalog: builder.query<HomeCatalogResponse, HomeCatalogQueryArgs>({
      query: ({isToggleEnabled, isImpersonationUser, impEmail}) => ({
        url: `/all-tiles`,
        method: 'GET',
        params: {
          is_toggle_enabled: isToggleEnabled,
          is_impersonation_user: isImpersonationUser,
          imp_email: isImpersonationUser ? impEmail : '',
        },
      }),
      keepUnusedDataFor: 10 * 60,
    }),
  }),
});

export const {useGetHomeCatalogQuery} = homeCatalogApi;
